import { AutogenModelState, AutogenRowState } from "./autogen/AutogenModelState";

export class ModelState extends AutogenModelState<RowState> {
	constructor() {
		super(RowState);
	}
}

export class RowState extends AutogenRowState {
}